namespace GeniuzPOS.PosShift {
    export interface PsTaxInvoicePrintData extends Serenity.ListRequest {
        Header?: PsTaxInvoiceHdRow;
        Addressdata?: PsTaxInvoiceAddressRow;
        Details?: PsTaxInvoiceDtRow[];
        DocNo?: string;
        Type?: number;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
